export const APP_INIT_START = 'APP_INIT_START' as const;
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS' as const;
export const APP_INIT_FAILURE = 'APP_INIT_FAILURE' as const;

export const APP_LOG = 'APP_LOG' as const;
export const LOG_ACTION = 'LOG_ACTION' as const;
export const LOG_APPSFLYER_ACTION = 'LOG_APPSFLYER_ACTION' as const;

export const OPEN_MODAL = 'OPEN_MODAL' as const;
export const CLOSE_MODAL = 'CLOSE_MODAL' as const;

export const USER_UPDATE_START = 'USER_UPDATE_START' as const;
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS' as const;
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE' as const;

export const USER_UPDATE_PASSWORD_START = 'USER_UPDATE_PASSWORD_START' as const;
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS' as const;
export const USER_UPDATE_PASSWORD_FAILURE = 'USER_UPDATE_PASSWORD_FAILURE' as const;

export const USER_PROMOCODE_APPLY_START = 'USER_PROMOCODE_APPLY_START' as const;
export const USER_PROMOCODE_APPLY_SUCCESS = 'USER_PROMOCODE_APPLY_SUCCESS' as const;
export const USER_PROMOCODE_APPLY_FAILURE = 'USER_PROMOCODE_APPLY_FAILURE' as const;

export const USER_PROMOCODE_REMOVE_START = 'USER_PROMOCODE_REMOVE_START' as const;
export const USER_PROMOCODE_REMOVE_SUCCESS = 'USER_PROMOCODE_REMOVE_SUCCESS' as const;
export const USER_PROMOCODE_REMOVE_FAILURE = 'USER_PROMOCODE_REMOVE_FAILURE' as const;

export const SET_IS_FIRST_LOGIN = 'SET_IS_FIRST_LOGIN' as const;

export const COMPLETE_ONBOARDING_START = 'COMPLETE_ONBOARDING_START' as const;
export const COMPLETE_ONBOARDING_SUCCESS = 'COMPLETE_ONBOARDING_SUCCESS' as const;
export const COMPLETE_ONBOARDING_FAILURE = 'COMPLETE_ONBOARDING_FAILURE' as const;

export const RESET_FORM_ERROR = 'RESET_FORM_ERROR' as const;

export const UPDATE_AB_TEST_IS_USED_START = 'UPDATE_AB_TEST_IS_USED_START' as const;
export const UPDATE_AB_TEST_IS_USED_SUCCESS = 'UPDATE_AB_TEST_IS_USED_SUCCESS' as const;
export const UPDATE_AB_TEST_IS_USED_FAILURE = 'UPDATE_AB_TEST_IS_USED_FAILURE' as const;

export const LOAD_ACCOUNT_TRADE_INFO_START = 'LOAD_ACCOUNT_TRADE_INFO_START' as const;
export const LOAD_ACCOUNT_TRADE_INFO_SUCCESS = 'LOAD_ACCOUNT_TRADE_INFO_SUCCESS' as const;
export const LOAD_ACCOUNT_TRADE_INFO_FAILURE = 'LOAD_ACCOUNT_TRADE_INFO_FAILURE' as const;

export const SET_RECENT_DONE = 'SET_RECENT_DONE' as const;
export const SET_USER_SELECTED_ACCOUNT_CODE = 'SET_USER_SELECTED_ACCOUNT_CODE' as const;

export const LOAD_ACCOUNT_HISTORY_START = 'LOAD_ACCOUNT_HISTORY_START' as const;
export const LOAD_ACCOUNT_HISTORY_SUCCESS = 'LOAD_ACCOUNT_HISTORY_SUCCESS' as const;
export const LOAD_ACCOUNT_HISTORY_FAILURE = 'LOAD_ACCOUNT_HISTORY_FAILURE' as const;

export const LOAD_ACCOUNT_HISTORY_INFO_START = 'LOAD_ACCOUNT_HISTORY_INFO_START' as const;
export const LOAD_ACCOUNT_HISTORY_INFO_SUCCESS = 'LOAD_ACCOUNT_HISTORY_INFO_SUCCESS' as const;
export const LOAD_ACCOUNT_HISTORY_INFO_FAILURE = 'LOAD_ACCOUNT_HISTORY_INFO_FAILURE' as const;

export const UPDATE_DEPOSIT_TRANSACTION_START = 'UPDATE_DEPOSIT_TRANSACTION_START' as const;
export const UPDATE_DEPOSIT_TRANSACTION_SUCCESS = 'UPDATE_DEPOSIT_TRANSACTION_SUCCESS' as const;
export const UPDATE_DEPOSIT_TRANSACTION_FAILURE = 'UPDATE_DEPOSIT_TRANSACTION_FAILURE' as const;

export const SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE = 'SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE' as const;
export const UPDATE_APP_LANG = 'UPDATE_APP_LANG' as const;
export const _ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE' as const;

export const BREAKPOINTS = {
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200,
    extraExtraLarge: 1400,
}

export const ROLES = {
    ROOT: 'root',
    ADMIN: 'admin',
    CLIENT: 'client',
}

export const LOCALE_CODES = {
    en: 'en',
};

export const LINKS = {
    clientAgreementDoc: '/docs/client-agreement.pdf' as const,
}

export const KEY_CODES = {
    ARROW_UP: 38,
    ARROW_DOWN: 38,
    BACKSPACE: 8,
    ENTER: 13,
};


